// removed by extract-text-webpack-plugin
module.exports = {"accordionContainer":"Accordion__accordionContainer___1CIcR","accordionItemContainer":"Accordion__accordionItemContainer___3Gejk","accordionTitle":"Accordion__accordionTitle___2HWLt","itemContainer":"Accordion__itemContainer___15SzN","arrowUp":"Accordion__arrowUp___3htyn","arrowDown":"Accordion__arrowDown___3izwd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Accordion/Accordion.scss
// module id = 469
// module chunks = 0